import {database} from '$src/store';

const requireComponent = require.context('.', false, /Model\.js$/);
requireComponent.keys().forEach((name) => {
    let module = requireComponent(name);
    database.register(module.default);
});